export const MET_ENDPOINT_TAGS = [
  'MANAGED_EVENT_TYPE_LIST'
]

export const MET_INVALIDATION_TAGS = {
  CREATE_EVENT_TYPE: ['MANAGED_EVENT_TYPE_LIST'],
}
